<template>
    <div :class="$style.locale_switchers">
        <LocaleSwitcher
            v-for="locale in supportedLocales"
            :key="locale"
            :size="props.size"
            :locale="locale"
        />
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import { useI18nAddon } from '@/i18n/i18n'

import LocaleSwitcher from './LocaleSwitcher.vue'

interface LocaleSwitcherListProps {
    size?: 'm' | 'l'
}

const props = withDefaults(defineProps<LocaleSwitcherListProps>(), {
    size: 'm',
})

const i18nAddon = useI18nAddon()

const supportedLocales = computed(() => i18nAddon.getSupportedLocales())
</script>

<style module>
.locale_switchers {
    padding-bottom: 16px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

@media (--tablet-plus) {
    .locale_switchers {
        padding-bottom: 24px;
    }
}
</style>
